import { generateTranslations } from '../i18n/translation';

const namespace = 'practiceactivitypsa';

const translations = generateTranslations(namespace, {
  loading: {
    nb: 'Laster aktivitet...',
    en: 'Loading activity...',
  },
  title: {
    nb: 'Praksisstudier i ',
    en: 'Courses in ',
  },
  subtitle: {
    nb: 'Fyll ut kapasitet på antall studenter dere kan motta for denne bestillingen.',
    en: 'Fill in capacity on number of students that you can receive for this order',
  },
  avbryt: {
    nb: 'Avbryt',
    en: 'Cancel',
  },
  tilbake: {
    nb: 'Til kalenderen',
    en: 'To the calendar',
  },
  activitytitle: {
    nb: 'Praksisaktivitet',
    en: 'Practice activity',
  },

  activitybestiller: {
    nb: 'Bestiller',
    en: 'Place of order',
  },
  activitystatus: {
    nb: 'Status',
    en: 'Status',
  },
  activitypraksistype: {
    nb: 'Praksistype',
    en: 'Practice type',
  },
  activityemnenavn: {
    nb: 'Emnenavn',
    en: 'Subject name',
  },
  activityemnebeskrivelse: {
    nb: 'Emnebeskrivelse',
    en: 'Subject description',
  },
  activityklasse: {
    nb: 'Praksisklasse',
    en: 'Practice Class',
  },
  activitykrav: {
    nb: 'Aktivitetskrav',
    en: 'Requirement',
  },
  activityingenkrav: {
    nb: 'Ingen aktivitetskrav',
    en: 'No requirement',
  },
  periodTitle: {
    nb: 'Praksisperiode',
    en: 'Practice period',
  },
  periodOppstart: {
    nb: 'Oppstart',
    en: 'Start',
  },
  periodAvslutning: {
    nb: 'Avslutning',
    en: 'End',
  },
  periodTotalBestillinger: {
    nb: 'Bestillinger',
    en: 'Orders',
  },
  periodTotalKapasiteter: {
    nb: 'Kapasiteter',
    en: 'Capacities',
  },
  steder: {
    nb: 'Steder',
    en: 'Places',
  },
  roller: {
    nb: 'Roller',
    en: 'Roles',
  },
  fordeling: {
    nb: 'Fordeling',
    en: 'Assignments',
  },
  detaljer: {
    nb: 'Detaljer',
    en: 'Details',
  },
  publisertTilFs: {
    nb: 'Du kan ikke legge inn kapasitet lenger, siden studenter er fordelt.',
    en: 'You cannot adjust capacity anymore since students are published.',
  },
  fritekstTitle: {
    nb: 'Om praksisaktiviteten',
    en: 'About the practice activity',
  },
  fritekstSubtitle: {
    nb: 'Informasjon om praksisaktiviteten sendt inn av koordinator ved studiestedet. Informasjonen er også sendt til studenter.',
    en: 'Information regarding the practice activity shared by a coordinator at the institution. This information is also shared with students.',
  },
});

export default translations;
